import React, { useEffect } from "react";
import {
  Cartesian3,
  Cartesian2,
  SceneMode,
  Math,
  Cartographic,
  Transforms,
  Matrix4,
} from "cesium";

export const FuncRotate = ({rfcs,rotateset}) => {
  useEffect(() => {
    function rotate() {
      rfcs.current.cesiumElement.scene.camera.rotateRight(0.005);
    }
    function rotate1(e) {
      if (rfcs.current.cesiumElement.scene.mode !== SceneMode.MORPHING) {
        if (rotateset) {
          var windowPosition = new Cartesian2(
            rfcs.current.cesiumElement.container.clientWidth / 2,
            rfcs.current.cesiumElement.container.clientHeight / 2
          );
          var ellipsoid = rfcs.current.cesiumElement.scene.globe.ellipsoid;
          var cartesian = rfcs.current.cesiumElement.camera.pickEllipsoid(
            windowPosition,
            ellipsoid
          );
          var carto2 = Cartographic.fromCartesian(cartesian);
          var center_lon = Math.toDegrees(carto2.longitude);
          var center_lat = Math.toDegrees(carto2.latitude);
          var cameraposition = rfcs.current.cesiumElement.camera.position;

          var center = Cartesian3.fromDegrees(center_lon, center_lat, 0);
          var transform = Transforms.eastNorthUpToFixedFrame(center);

          rfcs.current.cesiumElement.scene.camera.lookAtTransform(
            transform,
            cameraposition
          );

          rfcs.current.cesiumElement.clock.onTick.addEventListener(rotate);
          // }
        }
      }
    }
    rotate1();
    return () => {
      if (rotateset) {
        rfcs.current.cesiumElement.clock.onTick.removeEventListener(rotate);
        rfcs.current.cesiumElement.camera.lookAtTransform(Matrix4.IDENTITY);
      } else {
        // console.log("何もしない");
      }
    };
  }, [rotateset]);
  return <></>
};
